// Placement taxonomy/schema helpers – extracted from PlacementDetailsTableService
import { Utils } from '../../../shared';
import { CreatePlacementOrPackageService, PlacementUtils } from "../";

// Module-level mutable state for synthecticId (was `this.synthecticId` on the service object)
let _synthecticId = null;
export const getSynthecticId = () => _synthecticId;
export const setSynthecticId = (val) => { _synthecticId = val; };

export const updateFormDataWithJsonData = (taxonomyArray, taxonomyData, useHiddenFiled) => {
  let formData = {};
  const taxonomyFieldMap = new Map();
  taxonomyData?.forEach(field => {
    let allowCondition = field.hidden ? useHiddenFiled : true;
    if (allowCondition) {
      taxonomyFieldMap.set(field.id, field);
    }
  });
  taxonomyArray = Array.isArray(taxonomyArray) ? taxonomyArray : [];
  taxonomyArray?.filter(item => {
    const txonomyField = taxonomyFieldMap.get(item.id);
    return txonomyField;
  })
    .sort((a, b) => a.order - b.order)
    .forEach(item => {
      const txonomyField = taxonomyFieldMap.get(item.id);
      let fieldName = txonomyField.name || txonomyField.alias;
      formData[fieldName] = item.code;
    });
  return formData;
};

export const createArrayFromJson = (placementData, taxonomySchemaArray, synthecticDelimiter, isHidden) => {
  let nameArr = [];
  let jsonData = placementData.taxonomy;
  let synthecticId = '';
  if (Array.isArray(jsonData) && jsonData.length && taxonomySchemaArray && taxonomySchemaArray?.length) {
    jsonData.forEach((field) => {
      let value = taxonomySchemaArray?.find(item => item.id == field.id);
      let allowCondition = value?.hidden ? isHidden : true;
      if (value && allowCondition) {
        nameArr.push(field.code);
      }
    });
  }
  if (synthecticDelimiter && placementData?.placements_id) {
    synthecticId = synthecticDelimiter + placementData.placements_id;
    nameArr.push(synthecticId);
  }
  return { nameArr, syntheticId: synthecticId, nameLastIndex: nameArr.length - 1, isNameAndSchemaFieldMatch: true };
};

export function splitStringIntoArray(namesString, taxonomySchemaArray, synthecticDelimiter = null, isHidden = false, passPendingValue = false, placementData) {
  if (placementData?.taxonomy && synthecticDelimiter) {
    return createArrayFromJson(placementData, taxonomySchemaArray, synthecticDelimiter, isHidden);
  }

  let arr = [];
  let nameLastIndex = 0;
  let namesArr = [];
  let synthecticId = null;
  let finalTaxonomyArray = [];
  let isNameAndSchemaFieldMatch = true;
  let name = typeof namesString == 'string' ? namesString : String(namesString);
  if (name && synthecticDelimiter) {
    namesArr = name.split(synthecticDelimiter);
    name = namesArr[0];
  }
  if (isHidden)
    finalTaxonomyArray = taxonomySchemaArray;
  else
    finalTaxonomyArray = taxonomySchemaArray?.filter(val => !val?.hidden);
  if (!name || !(finalTaxonomyArray && finalTaxonomyArray?.length)) {
    return { nameArr: [], syntheticId: '', nameLastIndex: null, isNameAndSchemaFieldMatch: false };
  }
  let delimiterArray = finalTaxonomyArray.map(val => val.delimiterValue || val.delimiter_value);
  for (let i = 0; i < delimiterArray.length; i++) {
    let value = name.split(delimiterArray[i], 1);
    arr.push(value[0]);
    let index = name.indexOf(delimiterArray[i]);
    if (index === -1 && i !== delimiterArray.length - 1) {
      name = '';
    } else if (index === -1 && i === delimiterArray.length - 1) {
      name = '';
    } else {
      name = name.slice(index + 1);
    }
  }
  if (passPendingValue && name) {
    arr.push(name);
    name = '';
  }
  if (name) {
    return { nameArr: [], syntheticId: '', nameLastIndex: null, isNameAndSchemaFieldMatch: false };
  }
  nameLastIndex = arr.length - 1;
  isNameAndSchemaFieldMatch = arr?.filter(val => val !== '').length === delimiterArray.length;
  if (namesArr.length >= 2 && synthecticDelimiter) {
    arr.push(':|' + namesArr[1]);
    synthecticId = synthecticDelimiter + namesArr[1];
    isNameAndSchemaFieldMatch = arr?.filter(val => val !== '').length - 1 === delimiterArray.length;
  }
  arr = arr?.filter(val => val !== '');
  return { nameArr: arr, syntheticId: synthecticId, nameLastIndex: nameLastIndex, delimiterArr: delimiterArray, isNameAndSchemaFieldMatch: isNameAndSchemaFieldMatch };
}

export function splitPlacementStringIntoSchemaObject(namesString, schemaString, taxonomySchemaArray, synthecticDelimiter = null, isHidden = false, json = null) {
  let scehmaAndValue = {};
  if (json) {
    scehmaAndValue = updateFormDataWithJsonData(json, taxonomySchemaArray, isHidden);
  } else {
    if (!namesString || !schemaString) {
      return scehmaAndValue;
    }
    let finalTaxonomyArray = [];
    if (isHidden)
      finalTaxonomyArray = taxonomySchemaArray;
    else
      finalTaxonomyArray = taxonomySchemaArray?.filter(val => !val?.hidden);
    let schemaArrayOfString = schemaString.split('|');
    let valueArr = splitStringIntoArray(namesString, taxonomySchemaArray, synthecticDelimiter, isHidden, true)?.nameArr;
    if (valueArr.length > 2) {
      schemaArrayOfString.forEach((name, index) => {
        let value = valueArr[index]?.trim().toLowerCase();
        let field = finalTaxonomyArray.find(field => name == field.name || name == field.alias);
        let optionIsExist = null;
        if (field?.fielditems.length) {
          optionIsExist = field?.fielditems?.find(option => [option.name?.trim().toLowerCase(), option.code?.trim().toLowerCase()].includes(value));
        } else if (field?.dropDownValues?.length) {
          optionIsExist = field?.dropDownValues?.find(option => [option.label?.trim().toLowerCase(), option.value?.trim().toLowerCase()].includes(value));
        }
        if (field || optionIsExist) {
          scehmaAndValue[name] = valueArr[index];
        } else if (!field) {
          scehmaAndValue[name] = "NU";
        }
      });

      let emptyFieldCount = 0;
      const filteredValueLength = valueArr?.filter((item, index) => index !== valueArr?.length - 1 || item?.trim() !== '')?.length;
      schemaArrayOfString.forEach((schemaName, index) => {
        if (!scehmaAndValue[schemaName]) {
          let field = finalTaxonomyArray?.find(val => val.name === schemaName);
          if (field?.field_type !== 1) {
            if (schemaArrayOfString.length > filteredValueLength) {
              scehmaAndValue[schemaName] = valueArr[index - emptyFieldCount];
            } else {
              scehmaAndValue[schemaName] = valueArr[index];
            }
          } else {
            emptyFieldCount++;
          }
        }
      });
    }
  }
  return scehmaAndValue;
}

export const createStringFromJson = (jsonArray, label, useHiddenFiled = false, taxonomyData, isNewCreation = false) => {
  let name = '';
  const taxonomyFieldMap = new Map();
  taxonomyData?.forEach(field => {
    taxonomyFieldMap.set(field.id, field);
  });
  let lastAddedDelimiter = null;
  if (jsonArray.length) {
    let totalLength = jsonArray.length;
    jsonArray.forEach((field, index) => {
      const txonomyField = taxonomyFieldMap.get(field.id);
      let delimeter = label === 'field_name' ? '|' : field.delimiter;
      let allowCondition = txonomyField?.hidden ? useHiddenFiled : true;
      if (allowCondition && txonomyField) {
        if (isNewCreation && txonomyField.field_type === 10) {
          field[label] = "{TaxonomyValueID}";
        }
        if (totalLength - 1 === index) {
          name = name + field[label];
          lastAddedDelimiter = null;
        } else {
          name = name + field[label] + delimeter;
          lastAddedDelimiter = delimeter;
        }
      }
    });
  }
  if (lastAddedDelimiter) {
    name = name.slice(0, -1);
  }
  return name;
};

export function createStringFromArray(schemaDropDownArray, nameArr, schemaNameStringArr, isOverride = false) {
  if (isOverride) {
    let nameString = '';
    schemaNameStringArr.forEach((value, index) => {
      let field = schemaDropDownArray?.find(item => item.name == value || item.alias == value);
      if (index === nameArr.length - 1) {
        nameString = nameString + nameArr[index];
      } else {
        nameString = nameString + nameArr[index] + (field?.delimiterValue || field?.delimiter_value);
      }
    });
    return nameString;
  } else {
    let nameString = '';
    const updatedSchemaDropDownArray = schemaDropDownArray?.filter(val => !val?.hidden);
    schemaNameStringArr.forEach((value, index) => {
      let field = updatedSchemaDropDownArray?.find(item => item.name == value || item.alias == value);
      if (index === nameArr.length - 1) {
        nameString = nameString + nameArr[index];
      } else {
        nameString = nameString + nameArr[index] + (field?.delimiterValue || field?.delimiter_value);
      }
    });
    return nameString;
  }
}

export const createTemplateString = (fields) => {
  const result = { data: '', delimiters: [] };
  if (!fields?.length) return result;
  const delimeterValues = [];
  result.data = fields
    .filter((field) => !field?.hidden)
    .reduce((taxonomyString, field) => {
      const delimiterValue = field?.field_type === 10 ? 'taxonomyId' : 'string';
      delimeterValues.push(field?.delimiter_value);
      return taxonomyString + delimiterValue + field?.delimiter_value;
    }, '')
    .slice(0, -1);
  delimeterValues.pop();
  result.delimiters = delimeterValues;
  return result;
};

export const buildTaxonomyStrings = (allTaxonomyData) => {
  const taxonomyKeyMap = {
    defaultplacement: 'defaultTaxonomyData',
    directpackage: 'directPackageTaxonomyData',
    placement: 'placementTaxonomyData',
    directcreative: 'directCreativeTaxonomyData',
    programmaticpackage: 'programmaticPackageTaxonomyData',
    programmaticplacement: 'programmaticPlacementTaxonomyData',
    dsppackage: 'dspPackageTaxonomyData',
    creativepackage: 'creativePackageTaxonomyData',
    socialdirectpackage: 'socialDirectPackageTaxonomyData',
    socialdirectplacement: 'socialDirectPlacementTaxonomyData',
    socialdirectcreative: 'socialDirectCreativeTaxonomyData',
    socialprogrammaticpackage: 'socialProgrammaticPackageTaxonomyData',
    socialprogrammaticplacement: 'socialProgrammaticPlacementTaxonomyData',
    socialprogrammaticline: 'socialProgrammaticLineItemTaxonomyData',
    socialprogrammaticcreative: 'socialProgrammaticCreativeTaxonomyData',
    search: 'searchPackageTaxonomyData',
    feeorder: 'feeOrderTaxonomyData',
    offlinepackage: 'offlinePackageData',
    offlineestimatename: 'offlineEstimateNameData',
    doohpackage: 'oohPackageData',
    doohplacement: 'oohEstimateNameData',
    networkttvpackage: 'networkTvPackageData',
    networktvestimatename: 'networkTvEstimateNameData',
  };
  const result = {};
  for (const key in taxonomyKeyMap) {
    if (Object.hasOwnProperty.call(taxonomyKeyMap, key)) {
      result[key] = createTemplateString(allTaxonomyData?.[taxonomyKeyMap[key]]?.fields);
    }
  }
  return result;
};

export function createformDataForEditPlacement(placementData, taxonomyData, defaultTaxonomyData, socialProgrammaticFlag, isLocal, currency) {
  let defaultData = {};
  defaultData["Placement Name"] = placementData["placement_taxonomy"];
  defaultData["Parameter Code"] = placementData["parameter_code"];
  defaultData["Parameter Code Schema"] = placementData["parameter_code_taxonomy_schema"];
  defaultData["Parameter Code Display Name"] = placementData["parameter_code_taxonomy_display"];
  let schemaDelimiterValue = "|";

  let taxonomyNameString = placementData["override_taxonomy"] ? placementData["overriden_placement_taxonomy"] : (placementData["placement_taxonomy"] ? placementData["placement_taxonomy"] : "");
  let editFormData = [];
  let scehmaAndValue = {};
  if (!placementData?.taxonomy?.length) {
    editFormData = splitStringIntoArray(taxonomyNameString, taxonomyData?.fields, ':|', true, false, placementData).nameArr;
  } else {
    scehmaAndValue = updateFormDataWithJsonData(placementData['taxonomy'], taxonomyData?.fields, false);
  }

  let schemaArr = (placementData["taxonomy_schema"] || "").split(schemaDelimiterValue);
  if (!placementData["override_taxonomy"]) {
    for (let index in schemaArr) {
      const fieldName = schemaArr[index];
      if (!placementData?.taxonomy?.length) {
        defaultData[fieldName] = editFormData[index];
      } else {
        defaultData[fieldName] = scehmaAndValue[fieldName];
      }
    }
    let { taxonomySelectedValueJson } = PlacementUtils.createNames(defaultData, taxonomyData, true);
    placementData['taxonomy'] = taxonomySelectedValueJson;
  } else {
    placementData['isOverride'] = placementData["override_taxonomy"];
  }

  let parameterEditFormData = splitStringIntoArray(placementData["parameter_code"], defaultTaxonomyData).nameArr;
  let parameterSchema = (placementData["parameter_code_taxonomy_schema"] || "").split(schemaDelimiterValue);
  for (let index in parameterSchema) {
    defaultData["Parameter Code " + parameterSchema[index]] = parameterEditFormData[index];
  }

  defaultData["Flight Start"] = placementData["flight_start"] ? Utils.formatDateObject(placementData["flight_start"]) : "";
  defaultData["Flight End"] = placementData["flight_end"] ? Utils.formatDateObject(placementData["flight_end"]) : "";
  if (isLocal && currency) {
    defaultData["Rate"] = (placementData["rate_local"] || placementData["rate_local"] === 0) ? placementData["rate_local"] : "";
    defaultData["Planned Cost"] = placementData["planned_cost_local"] ? placementData["planned_cost_local"] : "";
  } else {
    defaultData["Rate"] = (placementData["rate"] || placementData["rate"] === 0) ? placementData["rate"] : "";
    defaultData["Planned Cost"] = placementData["planned_cost"] ? placementData["planned_cost"] : "";
  }

  defaultData["Unit Amount"] = (placementData["unit_amount"] || placementData["unit_amount"] === 0) ? placementData["unit_amount"] : "";
  defaultData["costMethod"] = placementData["cost_method"];
  let placementNameArray = defaultData["Placement Name"].split(':|');
  _synthecticId = placementData.placements_id;
  defaultData["Placement Name"] = placementNameArray[0];
  defaultData["costMethod"] = placementData["cost_method"];
  defaultData["Placement Name"] = placementData["placement_taxonomy"];
  defaultData["Placement Display Name"] = placementData["placement_taxonomy_display"];
  defaultData["Placement Schema"] = placementData["taxonomy_schema"];
  defaultData["programmaticType"] = CreatePlacementOrPackageService.getProgrammaticType(placementData["package_type"], socialProgrammaticFlag);
  defaultData['taxonomy_client_id'] = taxonomyData?.clientid;
  defaultData['taxonomy_schema_id'] = taxonomyData?.id;
  return defaultData;
}

export const getFormEditData = (taxonomyData, placementData, placementColumn = null) => {
  let isHiddenFields = false;
  let hiddenSchemaArr = [];
  let notHiddenSchemaArr = [];
  for (let i = 0; i < taxonomyData?.length; i++) {
    if (taxonomyData[i].hidden) {
      isHiddenFields = true;
      hiddenSchemaArr.push(taxonomyData[i].name);
    } else {
      notHiddenSchemaArr.push(taxonomyData[i].name);
      hiddenSchemaArr.push(taxonomyData[i].name);
    }
  }
  let taxonomyNameString;
  let schemaArr = [];
  if (!isHiddenFields) {
    taxonomyNameString = placementColumn === "parameter_code" ? placementData["parameter_code"] : (placementData["override_taxonomy"] ? placementData["overriden_placement_taxonomy"] : (placementData["placement_taxonomy"] ? placementData["placement_taxonomy"] : ""));
    schemaArr = notHiddenSchemaArr;
  } else {
    taxonomyNameString = placementColumn === "parameter_code" ? placementData["parameter_code"] : (placementData["overriden_placement_taxonomy"] ? placementData["overriden_placement_taxonomy"] : (placementData["placement_taxonomy"] ? placementData["placement_taxonomy"] : ""));
    schemaArr = hiddenSchemaArr;
  }
  let placementJson = placementColumn === "parameter_code" ? null : (placementData?.taxonomy ? placementData.taxonomy : null);
  let hidenSchemaString = schemaArr.join('|');
  let editFormData = splitPlacementStringIntoSchemaObject(taxonomyNameString, hidenSchemaString, taxonomyData, ':|', isHiddenFields, placementJson);
  return { schemaArr, editFormData };
};

export const compareTaxonomyAndData = (taxonomyFields, editData, currentSchema, taxonomyArray) => {
  if (taxonomyArray && taxonomyArray.length) {
    const taxonomyIdSet = new Set(taxonomyArray.map(item => item.id));
    const fieldIdSet = new Set(taxonomyFields?.map(field => field.id));
    if (taxonomyIdSet.size !== fieldIdSet.size) return false;
    for (const id of fieldIdSet) {
      if (!taxonomyIdSet.has(id)) return false;
    }
    return true;
  }
  if (!taxonomyFields || !editData) return false;
  taxonomyFields = taxonomyFields?.filter(field => !field.hidden);
  let editDataKeys = Object.keys(editData);
  for (let i = 0; i < taxonomyFields.length; i++) {
    let field = taxonomyFields[i];
    if (!editDataKeys.includes(field.name) && !editDataKeys.includes(field.alias)) return false;
  }
  let newSchema = taxonomyFields?.map(field => field.name || field.alias);
  let newSchemaWithAlias = taxonomyFields?.map(field => field.alias);
  let oldSchema = currentSchema ? currentSchema.split('|') : [];
  if (newSchema.length !== oldSchema.length) return false;
  for (let i = 0; i < newSchema.length; i++) {
    if (newSchema[i]?.trim() !== oldSchema[i]?.trim() && newSchemaWithAlias[i]?.trim() !== oldSchema[i]?.trim()) return false;
  }
  return true;
};

export const getDefaultValuesForParameterCode = (defaultTaxonomyFields) => {
  const result = {};
  if (!defaultTaxonomyFields || !defaultTaxonomyFields.length) return result;
  defaultTaxonomyFields.forEach((field) => {
    const fieldName = field?.name || field?.alias || `field_${field?.id}`;
    result[fieldName] = 'NA';
  });
  return result;
};

export const getErrorMessage = (result, placementName) => {
  if (result?.validationResults && result?.validationResults[placementName]) {
    return result?.validationResults[placementName];
  } else {
    return result?.message || result?.validation;
  }
};
